export const CAPACITY_DAILY_HOURS = 8

export const CAPACITY_STATUS = {
    ALL: 'all',
    OCCUPIED: 'occupied',
    PARTIAL: 'partial',
    AVAILABLE: 'available',
}

export const CAPACITY_STATUS_OPTIONS = [
    { value: CAPACITY_STATUS.ALL, label: 'All' },
    { value: CAPACITY_STATUS.OCCUPIED, label: 'Occupied' },
    { value: CAPACITY_STATUS.PARTIAL, label: 'Partially Available' },
    { value: CAPACITY_STATUS.AVAILABLE, label: 'Available' },
]

export const CAPACITY_STATUS_LABELS = {
    [CAPACITY_STATUS.OCCUPIED]: 'Occupied',
    [CAPACITY_STATUS.PARTIAL]: 'Partially Available',
    [CAPACITY_STATUS.AVAILABLE]: 'Available',
}

export const CAPACITY_STATUS_COLORS = {
    [CAPACITY_STATUS.OCCUPIED]: '#ef4444',
    [CAPACITY_STATUS.PARTIAL]: '#f59e0b',
    [CAPACITY_STATUS.AVAILABLE]: '#22c55e',
}

export const CAPACITY_STATUS_BG = {
    [CAPACITY_STATUS.OCCUPIED]: '#fef2f2',
    [CAPACITY_STATUS.PARTIAL]: '#fffbeb',
    [CAPACITY_STATUS.AVAILABLE]: '#f0fdf4',
}

export const CAPACITY_PARTIAL_THRESHOLD = 80
export const CAPACITY_OCCUPIED_THRESHOLD = 100

export const CAPACITY_API_STATUS = {
    [CAPACITY_STATUS.ALL]: 'All',
    [CAPACITY_STATUS.OCCUPIED]: 'Occupied',
    [CAPACITY_STATUS.PARTIAL]: 'Partially Available',
    [CAPACITY_STATUS.AVAILABLE]: 'Available',
}
